import { render, staticRenderFns } from "./afs.vue?vue&type=template&id=06e74a34"
import script from "./afs.vue?vue&type=script&lang=js"
export * from "./afs.vue?vue&type=script&lang=js"
import style0 from "./afs.vue?vue&type=style&index=0&id=06e74a34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports